export default __webpack_public_path__ + "static/media/36I-117125_-37252_0.855d39b5.jpg";